import { GroupsService } from '@/service/GroupsService'
import Model from './Model'

export interface IGroup {
  _id?: string
  locationId: string
  name: string
  description: string
  slug: string | undefined
  branding?: object
  settings?: object
  promotionalLinks: []
  createdBy: string
  paymentPriceId: string
  paymentProductId: string
  marketplaceGroupSlug: string
}

export enum GroupStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum GroupType {
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}
export enum MembershipType {
  FREE = 'FREE',
  PAID = 'PAID',
  GAMIFICATION_LEVEL = 'GAMIFICATION_LEVEL',
  TIME_ACCESS = 'TIME_ACCESS',
  PRIVATE_CHANNEL = 'PRIVATE_CHANNEL',
}

export enum SubscriptionType {
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
  FREE = 'FREE',
}

export enum SubscriptionInterval {
  ANNUAL = 'YEAR',
  MONTHLY = 'MONTH',
  WEEKLY = 'WEEK',
}

export default class Groups extends Model {
  constructor(payload: IGroup) {
    super(payload, GroupsService)
  }

  set id(_id: string) {
    this._data._id = _id
  }

  get id(): string {
    return this._data._id
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get name(): string {
    return this._data.name
  }

  set name(name: string) {
    this._data.name = name
  }

  get description(): string {
    return this._data.description
  }

  set description(description: string) {
    this._data.description = description
  }

  get slug(): string {
    return this._data.slug
  }

  set slug(slug: string) {
    this._data.slug = slug
  }

  get branding(): object {
    return this._data.branding
  }

  set branding(branding: object) {
    this._data.branding = branding
  }

  get settings(): any {
    return this._data.settings
  }

  set settings(settings: any) {
    this._data.settings = settings
  }
  get promotionalLinks(): object {
    return this._data.promotionalLinks
  }

  set promotionalLinks(promotionalLinks: object) {
    this._data.promotionalLinks = promotionalLinks
  }

  get createdBy(): string {
    return this._data.createdBy
  }

  set createdBy(createdBy: string) {
    this._data.createdBy = createdBy
  }

  set paymentProductId(paymentProductId: string) {
    this._data.paymentProductId = paymentProductId
  }

  get paymentProductId(): string {
    return this._data.paymentProductId
  }
  set paymentPriceId(paymentPriceId: string) {
    this._data.paymentPriceId = paymentPriceId
  }

  get paymentPriceId(): string {
    return this._data.paymentPriceId
  }

  get marketplaceGroupSlug(): string {
    return this._data.marketplaceGroupSlug
  }

  set marketplaceGroupSlug(marketplaceGroupSlug: string) {
    this._data.marketplaceGroupSlug = marketplaceGroupSlug
  }
}

export enum MemberStatus {
  ACTIVE = 'Active',
  REQUESTED = 'Requested',
  INVITED = 'Invited',
  BANNED = 'Banned',
  PAYMENT_RECEIVED = 'PaymentReceived',
  PAYMENT_INITIATED = 'PaymentInitiated',
}
